import { gqlQuery } from '@hapana/shared/web/services/requests.service'

import { sitePaymentGatewayOnboardingStatusQuery } from './graphql/payment-gateway.queries'

const SITE_PAYMENT_GATEWAY_ONBOARDING_STATUS = 'SITE_PAYMENT_GATEWAY_ONBOARDING_STATUS'

export const getSitePaymentGatewayOnboardingStatus = gqlQuery({
  key: SITE_PAYMENT_GATEWAY_ONBOARDING_STATUS,
  query: sitePaymentGatewayOnboardingStatusQuery,
  options: {
    isV1: false,
  },
})
